const endpoints = {
  development: {
    login: {
      userLogin: "login",
      getSections: "sections",
      userLoginSSO: "keycloak/realms/backoffice/protocol/openid-connect/auth"
    },

    collections: {
      getProducts: "/products",
      getTypeEnums: "/typeEnums",
    },

    machines: {
      getMachinesCountry: (country) => `machines/${country}`,
      getMachinesModel: (modelNumber) => `machines/${modelNumber}`,
      getMachines: "bo/machines",
      postMachine: "machines",
      putMachine: (modelNumber) => `machines/${modelNumber}`,
      deleteMachine: (modelNumber) => `machines/${modelNumber}`,
    },
    mappings: {
      getMappings: (dsn) => `machines/${dsn}/iotmappings`,
      postMapping: (dsn) => `machines/${dsn}/iotmappings`,
      putMapping: (dsn) => `machines/${dsn}/iotmappings`,
      deleteMapping: (dsn) => `machines/${dsn}/iotmappings`,
    },
    recipes: {
      getRecipesCountry: (country) => `recipes/${country}`,
      getRecipesModel: (id) => `recipes/${id}`,
      getRecipes: "bo/recipes",
      postRecipe: "recipes",
      putRecipe: (id) => `recipes/${id}`,
      deleteRecipe: (id) => `recipes/${id}`,
    },
    contents: {
      strapi: "/contents",
      userInfo: "user/info",
    },

    products: {
      getProducts: "product",
    },

    //bo event controller
    events: {
      getEvents: "bo/event",
      getEventById: (id) => `bo/event/${id}`,
      postEvent: "bo/event",
      deleteEvent: (id) => `bo/event/${id}`,
    },
    collections: {
      getProducts: "/products",
      getTypeEnums: "/typeEnums",
    },
  },
  quality: {
    login: {
      userLogin: "keycloak/realms/backoffice/protocol/openid-connect/token",
      getSections: "sections",
      userLoginSSO: "keycloak/realms/backoffice/protocol/openid-connect/auth"
    },
    machines: {
      getMachinesCountry: (country) => `modular-engine/bo/machines/${country}`,
      getMachinesModel: (modelNumber) =>
        `modular-engine/bo/machines/${modelNumber}`,
      getMachines: "modular-engine/bo/machines",
      postMachine: "modular-engine/bo/machines",
      putMachine: (modelNumber) => `modular-engine/bo/machines/${modelNumber}`,
      deleteMachine: (modelNumber) =>
        `modular-engine/bo/machines/${modelNumber}`,
    },
    mappings: {
      getMappings: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      postMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      putMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      deleteMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
    },
    recipes: {
      getRecipesCountry: (country) => `modular-engine/recipes/${country}`,
      getRecipesModel: (id) => `modular-engine/modular-engine/recipes/${id}`,
      getRecipes: "modular-engine/recipes",
      postRecipe: "modular-engine/recipes",
      putRecipe: (id) => `modular-engine/recipes/${id}`,
      deleteRecipe: (id) => `modular-engine/recipes/${id}`,
    },
    contents: {
      strapi: "/contents",
      userInfo: "user/info",
    },
    products: {
      getProducts: "product",
    },
  },
  preprod: {
    login: {
      userLogin: "keycloak/realms/backoffice/protocol/openid-connect/token",
      getSections: "sections",
      userLoginSSO: "keycloak/realms/backoffice/protocol/openid-connect/auth"
    },
    machines: {
      getMachinesCountry: (country) => `modular-engine/bo/machines/${country}`,
      getMachinesModel: (modelNumber) =>
        `modular-engine/bo/machines/${modelNumber}`,
      getMachines: "modular-engine/bo/machines",
      postMachine: "modular-engine/bo/machines",
      putMachine: (modelNumber) => `modular-engine/bo/machines/${modelNumber}`,
      deleteMachine: (modelNumber) =>
        `modular-engine/bo/machines/${modelNumber}`,
    },
    mappings: {
      getMappings: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      postMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      putMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      deleteMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
    },
    recipes: {
      getRecipesCountry: (country) => `modular-engine/bo/recipes/${country}`,
      getRecipesModel: (id) => `modular-engine/bo/recipes/${id}`,
      getRecipes: "modular-engine/bo/recipes",
      postRecipe: "modular-engine/bo/recipes",
      putRecipe: (id) => `modular-engine/bo/recipes/${id}`,
      deleteRecipe: (id) => `modular-engine/bo/recipes/${id}`,
    },
    contents: {
      strapi: "/contents",
      userInfo: "user/info",
    },
    products: {
      getProducts: "product",
    },
  },
  production: {
    login: {
      userLogin: "keycloak/realms/backoffice/protocol/openid-connect/token",
      getSections: "sections",
      userLoginSSO: "keycloak/realms/backoffice/protocol/openid-connect/auth"
    },
    machines: {
      getMachinesCountry: (country) => `modular-engine/machines/${country}`,
      getMachinesModel: (modelNumber) =>
        `modular-engine/machines/${modelNumber}`,
      getMachines: "modular-engine/bo/machines",
      postMachine: "modular-engine/bo/machines",
      putMachine: (modelNumber) => `modular-engine/bo/machines/${modelNumber}`,
      deleteMachine: (modelNumber) =>
        `modular-engine/bo/machines/${modelNumber}`,
    },
    mappings: {
      getMappings: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      postMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      putMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
      deleteMapping: (dsn) => `modular-engine/bo/machines/${dsn}/iotmappings`,
    },
    recipes: {
      getRecipesCountry: (country) => `modular-engine/recipes/${country}`,
      getRecipesModel: (id) => `modular-engine/bo/recipes/${id}`,
      getRecipes: "modular-engine/bo/recipes",
      postRecipe: "modular-engine/bo/recipes",
      putRecipe: (id) => `modular-engine/bo/recipes/${id}`,
      deleteRecipe: (id) => `modular-engine/bo/recipes/${id}`,
    },
    contents: {
      strapi: "/contents",
      userInfo: "user/info",
    },
    products: {
      getProducts: "product",
    },
  },
};

export default endpoints[process.env.REACT_APP_ENV];
